import { Alert, Text } from '@cencosud-cencommerce/paris-uikit';

const CommuneStoreAlert = () => (
  <Alert
    body={
      <Text variant="caption" weight={400} color="neutral-900">
        {' '}
        Te asignamos una opción dentro de tu región pero puedes elegir
        otra.{' '}
      </Text>
    }
    status="warning"
    title={
      <Text variant="body2" weight={600} color="neutral-900">
        {' '}
        El retiro no está disponible en tu comuna{' '}
      </Text>
    }
  />
);

export default CommuneStoreAlert;
